import { trigger, state, style, transition, animate } from '@angular/animations';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LayerDTO } from 'src/app/features/locations-map/models/LayerDTO';
import { LayerGroup } from 'src/app/features/locations-map/models/LayerGroups';
import { GeneratedLayerService } from 'src/app/features/locations-map/services/Generated-Layer.service';
import { PanelInternalLayerService } from 'src/app/features/locations-map/services/Panel-Internal-Layer.service';

@Component({
  selector: "app-generated-layers",
  templateUrl: "./generated-layers.component.html",
  styleUrls: ["./generated-layers.component.css"],
  animations: [
    trigger("ExpandCollapseGenerated", [
      state("expanded", style({ opacity: 1, height: "*" })),
      state("collapsed", style({ opacity: 0, height: "0px", overflow: "hidden", display: "none" })),
      transition("expanded <=> collapsed", animate("300ms ease-in-out")),
    ]),
  ],
})
export class GeneratedLayersComponent {
  listaCapasVisible: boolean = false;
  hasVirtualCategories: boolean = false;
  hasGPSCategories: boolean = true;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  $grupoCapas = new Array<LayerGroup>();

  $capasService: Observable<any>;

  subscription_GetLayers: Subscription;

  constructor(
    public generatedLayerService: GeneratedLayerService,
    private media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private panelInternalLayerService: PanelInternalLayerService
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.$capasService = this.generatedLayerService.getGroupLayers();
    this.subscription_GetLayers = this.$capasService.subscribe(
      (data) => {
        this.$grupoCapas = data;
        console.log("Capas generadas: ", this.$grupoCapas);
        
      }
    );
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.subscription_GetLayers)
      this.subscription_GetLayers.unsubscribe();
  }

  //se acciona al presionar el switch de una capa, capaActivada es el evento seleciconado
  onToggleLayer(layerGroup: LayerGroup, layer: LayerDTO) {
    this.generatedLayerService.onToggleLayer(layerGroup.name, layer.name);
  }

  toggleGeneratedLayers() {
    this.generatedLayerService.isGeneratedLayersExpanded = !this.generatedLayerService.isGeneratedLayersExpanded;
  }

  toggleGeneratedGroupLayers(grupo: LayerGroup) {
    this.$grupoCapas.find(g => g.name === grupo.name).isGeneratedLayerGroupExpanded = !grupo.isGeneratedLayerGroupExpanded;
    this.generatedLayerService.setCapas(this.$grupoCapas);
  }

  onExpandCollapseStart(event: any) {
    this.panelInternalLayerService.isExpandCollapseAnimating = true;
  }

  onExpandCollapseDone(event: any) {
    this.panelInternalLayerService.isExpandCollapseAnimating = false;
  }

}
